import { LegalLayout, Block } from "../components/LegalLayout";
import { CONTACT } from "../data";

export default function Datenschutz() {
  return (
    <LegalLayout title="Datenschutzerklärung">
      <Block heading="1. Verantwortlicher">
        <p>{CONTACT.company}</p>
        <p>{CONTACT.owner}</p>
        <p>{CONTACT.address}</p>
        <p>E-Mail: {CONTACT.email}</p>
        <p>Telefon: {CONTACT.phone}</p>
      </Block>

      <Block heading="2. Erhebung und Speicherung personenbezogener Daten">
        <p>
          Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch
          Informationen an den Server unserer Website gesendet (z. B. IP-Adresse, Datum und Uhrzeit der Anfrage, Browsertyp,
          Betriebssystem, Referrer-URL). Diese Daten sind technisch notwendig für die Anzeige unserer Website und dienen der
          Sicherheit unserer IT-Systeme.
        </p>
      </Block>

      <Block heading="3. Kontaktformular & WhatsApp">
        <p>
          Bei einer Kontaktaufnahme über unser Formular oder per WhatsApp werden die von Ihnen mitgeteilten Daten (Name,
          E-Mail-Adresse, Telefonnummer, Nachricht) zur Bearbeitung Ihrer Anfrage und für den Fall von Anschlussfragen bei
          uns gespeichert. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) bzw.
          lit. f DSGVO (berechtigtes Interesse). Hinweis: WhatsApp ist ein Dienst der Meta Platforms Ireland Ltd. — mit der
          Kontaktaufnahme übermitteln Sie Daten an Meta. Nähere Informationen finden Sie in der Datenschutzerklärung von
          WhatsApp.
        </p>
      </Block>

      <Block heading="4. Cookies">
        <p>
          Wir verwenden ausschließlich technisch notwendige Cookies, die für den sicheren Betrieb der Plattform erforderlich
          sind. Eine Verarbeitung zu Marketing- oder Trackingzwecken findet ohne Ihre Einwilligung nicht statt.
        </p>
      </Block>

      <Block heading="5. Ihre Rechte">
        <p>
          Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO),
          Einschränkung der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) sowie Widerspruch gegen die
          Verarbeitung (Art. 21 DSGVO). Bitte richten Sie Ihr Anliegen an die oben genannten Kontaktdaten. Außerdem können
          Sie sich bei einer Datenschutz-Aufsichtsbehörde beschweren.
        </p>
      </Block>

      <Block heading="6. Speicherdauer">
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie es für die jeweiligen Zwecke erforderlich ist bzw.
          gesetzliche Aufbewahrungspflichten dies vorschreiben. Anschließend werden die Daten gelöscht.
        </p>
      </Block>

      <Block heading="7. SSL-Verschlüsselung">
        <p>
          Unsere Website nutzt aus Sicherheitsgründen eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          am „https://“ in der Adresszeile Ihres Browsers.
        </p>
      </Block>

      <Block heading="8. Änderungen dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen
          Anforderungen entspricht. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
        </p>
      </Block>
    </LegalLayout>
  );
}
